module.exports = __webpack_public_path__ + "static/img/download_bg_04.577fc2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_bg_04.png
// module id = EPs4
// module chunks = 1